// extracted by mini-css-extract-plugin
module.exports = {"heading-wrapper":"BrowserView_heading-wrapper__1SnfX","content-left":"BrowserView_content-left__2c93x","draft-badge":"BrowserView_draft-badge__3ixGz"};